/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowRoundSyncForwardIcon20Light = forwardRef('ArrowRoundSyncForwardIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.305 3.035A7 7 0 0 1 16.325 7h-2.826a.5.5 0 0 0 0 1H17.5a.5.5 0 0 0 .5-.5V3.275a.5.5 0 0 0-1 0v2.852A8 8 0 0 0 2.16 8.412a.5.5 0 0 0 .98.199 7 7 0 0 1 6.165-5.576Z" }),
        React.createElement("path", { d: "M6.418 16.014a7 7 0 0 0 10.439-4.605.5.5 0 0 1 .98.202A8 8 0 0 1 3 13.873v2.85a.5.5 0 1 1-1 0V12.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H3.674a7 7 0 0 0 2.743 3.014Z" })));
});
